export interface ISoundPlayer {
    Player: AudioContext;
    PlayList: Array<SoundTrack>;
    // Display Data...
    Title: string;
    // Player State
    IsWaiting: boolean;
    PlayStop: boolean;

    setSoundTrack(track: SoundTrack): void;
    addToQueue(AudioTrack: any): void;
    onEnded(): void;
    reset(sensorID?: number): void
}

export class SoundTrack {
    Source: AudioBufferSourceNode;
    Title: string;
    Time: Date;

    constructor() {

    }
}